import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import RouteWrapper from "@/components/common/RouteWrapper.vue";

import Roles from "@/entities/Roles";

const Dashboard = () =>
  import("@/views/dashboard/Dashboard.vue").then((m) => m.default);

const getDashboardRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "dashboard",
    name: RouteNames.DASHBOARD,
    component: RouteWrapper,
    meta: {
      title: "Dashboard",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.DASHBOARD,
        // icon: NavigationIcons.DASHBOARD,
        routeName: RouteNames.DASHBOARD,
        isStyled: true,
      },
    },
  },
]);
const getDashboardChildRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    name: RouteNames.DASHBOARD,
    component: Dashboard,
    meta: {
      title: "Dashboard",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

export { getDashboardRoutes, getDashboardChildRoutes };
